/**
 * STOP!
 * If you are trying to show a global flash message to the user, use `shared/view/flash_message` instead.
 * Use this only when you need to render a flash message in a specific location.
 *
 * @example
 *
 * this.initSubview(FlashMessage, {
 *   type: 'warning',
 *   message: 'Be careful'
 * }).render();
 */
import View from 'view/view'
import template from 'component/flash_message/template/message.tmpl'

const ALLOWED_TYPES = ['success', 'warning', 'error']

export default View.extend({
    template,

    events: {
        click: '_onClick',
    },

    defaultOptions: {
        message: '',
        type: '',
    },

    initialize(options) {
        this.options = this.pickOptions(options, this.defaultOptions)

        if (!this.options.message) {
            throw new Error('Option `message` should be provided.')
        }

        this._ensureType(this.options.type)
    },

    _ensureType(type) {
        if (ALLOWED_TYPES.indexOf(type) === -1) {
            throw new Error(`Option "type" should be one of the following values: ${ALLOWED_TYPES.join('|')}`)
        }
    },

    fadeOut() {
        return new Promise((resolve, reject) => {
            this.$el.fadeOut({
                done: resolve,
                fail: reject,
            })
        })
    },

    render() {
        this.$el.html(
            this.template({
                message: {
                    message: this.options.message,
                    type: this.options.type,
                },
            })
        )

        return this
    },

    _onClick() {
        this.trigger('FlashMessage:click')
    },
})
